import Title from './Title/Title';
import GetInTouch from '../Contact/GetInTouch/GetInTouch';
import Map from '../Contact/Map/Map';
import { Helmet } from 'react-helmet-async';


function Home() {
    return (
        <div>
            <Helmet><title>Phoenix Object Conservation</title></Helmet>
            <Title />
            <GetInTouch />
            <Map />
        </div>
    );
}

export default Home;